import { ApplicationConfig, inject, isDevMode, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withNavigationErrorHandler } from '@angular/router';

import { routes } from '@/app.routes';
import { provideZard } from '@/shared/core/provider/providezard';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AppConfigService } from './app-config.service';
import { staleChunkNavigationErrorHandler } from './stale-chunk-error-handler';
import { authInterceptor } from '../auth/auth.interceptor';
import { loaderInterceptor } from '../loading/loader.interceptor';
import { getDedupeInterceptor } from '../interceptors/get-dedupe.interceptor';
import { idempotencyInterceptor } from '../interceptors/idempotency.interceptor';
import { TranslocoHttpLoader } from '../transloco/transloco-loader';
import { provideTransloco } from '@jsverse/transloco';

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        // Loads /assets/config/app-config.json before anything else (API URLs, idle timeout, flags)
        provideAppInitializer(() => inject(AppConfigService).load()),
        provideRouter(routes, withNavigationErrorHandler(staleChunkNavigationErrorHandler)),
        provideZard(),
        provideHttpClient(withInterceptors([authInterceptor, loaderInterceptor, getDedupeInterceptor, idempotencyInterceptor])),
        provideTransloco({
            config: {
                availableLangs: ['en'],
                defaultLang: 'en',
                prodMode: !isDevMode(),
            },
            loader: TranslocoHttpLoader,
        }),
    ],
};
